// src/pages/ResetPasswordPage.js
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useToast } from '../components/Toast'
import Navbar from '../components/Navbar'
import SocialFooter from '../components/SocialFooter'
import './AuthPage.css'

export default function ResetPasswordPage() {
  const navigate = useNavigate()
  const toast    = useToast()
  const [password, setPassword] = useState('')
  const [confirm,  setConfirm]  = useState('')
  const [showPass, setShowPass] = useState(false)
  const [loading, setLoading]   = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (password.length < 8) { toast.show('Password must be at least 8 characters', 'error'); return }
    if (password !== confirm) { toast.show('Passwords do not match', 'error'); return }
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    setLoading(false)
    if (error) { toast.show(error.message, 'error'); return }
    toast.show('Password updated! Signing you in...', 'success')
    setTimeout(() => navigate('/dashboard'), 1500)
  }

  return (
    <div className="auth-page">
      <Navbar />
      <div className="auth-wrap">
        <div className="auth-box">
          <div className="auth-box__header">
            <p className="auth-box__eyebrow">Account Recovery</p>
            <h1 className="auth-box__title">New Password</h1>
            <p className="auth-box__sub">Choose a strong new password</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label>New Password</label>
              <div className="pass-wrap">
                <input type={showPass ? 'text' : 'password'} placeholder="Minimum 8 characters"
                  value={password} onChange={e => setPassword(e.target.value)} required autoComplete="new-password" />
                <button type="button" className="pass-toggle" onClick={() => setShowPass(v => !v)}>{showPass ? '🙈' : '👁'}</button>
              </div>
            </div>
            <div className="field">
              <label>Confirm Password</label>
              <input type="password" placeholder="Repeat your new password"
                value={confirm} onChange={e => setConfirm(e.target.value)} required autoComplete="new-password" />
            </div>
            <button className="btn btn--gold btn--full" type="submit" disabled={loading} style={{marginTop:8}}>
              {loading ? 'Updating...' : 'Set New Password'}
            </button>
          </form>
        </div>
      </div>
      <SocialFooter />
    </div>
  )
}
